import React, { useState } from 'react';
import { Provider } from 'react-redux';
import { Container, Row, Col } from 'react-bootstrap';
import { ClickAwayListener } from '@material-ui/core';

import store from '../redux/store.js';
import '../App.css';

function Folder(props) {
  const [selection, setSelection] = useState('');
  const [hover, setHover] = useState('');
  const [logo, setLogo] = useState(null);
  const [onDetails, setOnDetails] = useState(false);
  const [height, setHeight] = useState('');
  const [width, setWidth] = useState('');
  const [details, setDetails] = useState(null);

  const setBackgroundColor = (fileName) => {
    if (selection === fileName) {
      return 'rgba(0, 123, 167, 0.5)';
    } else {
      if (hover === fileName) {
        return 'rgba(0, 123, 167, 0.2)';
      } else {
        return 'transparent';
      }
    }
  }

  const select = (fileName, logo, height, width, details) => {
    setSelection(fileName);
    setLogo(logo);
    setHeight(height);
    setWidth(width);
    setDetails(details);
  }

  return(
    <Provider store={store}>
      <div className='Folder'>
        {props.title}
      </div>
      <div className='horizontalDivider' />
      <Container fluid style={{height: 'calc(95vh - 48px)', width: '70%', position: 'absolute', left: 0, padding: 0, marginTop: 10, marginBottom: 10}}>
        {
          props.items.map((files) => {
            return(
              <div key={files['year']}>
                <Col lg={12} style={{fontSize: 20, color: '#4169E1'}}>
                  <Row style={{margin: 0, alignItems: 'center'}}>
                    {files['year']}
                    <Col>
                      <div style={{height: '1px', width: '100%', backgroundColor: '#4169E1'}}/>
                    </Col>
                  </Row>
                </Col>
                {
                  files['items'].map((item) => {
                    return(
                      <ClickAwayListener key={item['id']} onClickAway={() => onDetails ? null : (selection === item['id'] ? select('', null) : null)}>
                        <Row style={{width: '100%', margin: '0'}} onClick={() => select(item['id'], item['logo'], item['height'], item['width'], item['details'])} onMouseEnter={() => setHover(item['id'])} onMouseLeave={() => setHover('')}>
                          <Col lg={12} style={{paddingLeft: '2vw', backgroundColor: setBackgroundColor(item['id'])}}>
                            {item['name']}
                          </Col>
                        </Row>
                      </ClickAwayListener>
                    )
                  })
                }
              </div>
            )
          })
        }
      </Container>
      <div className='folderVerticalDivider' />
      {
      selection === '' ? null :
        <Container fluid style={{height: 'calc(95vh - 48px)', width: '30%', position: 'absolute', right: 0, padding: 0}}>
          <Row style={{height: '100%', width: '100%', margin: 0, padding: 20, overflowY: 'scroll'}}>
            <Col>
              <Row style={{justifyContent: 'center', paddingBottom: '5vh'}} onMouseEnter={() => setOnDetails(true)} onMouseLeave={() => setOnDetails(false)}>
                <img src={logo} alt={selection} style={{height: height, width: width}} />
              </Row>
              {
                details.map((detail) => {
                  return(
                    <Row key={detail.key} onMouseEnter={() => setOnDetails(true)} onMouseLeave={() => setOnDetails(false)}>
                      <Col lg={3} style={{fontWeight: 'bold'}}>
                        {detail.key}
                      </Col>
                      <Col lg={9} style={{display: 'flex', alignItems: 'center'}}>
                        {detail.key === "Link" ? <a href={detail.value} target="_blank" rel="noreferrer">{detail.value}</a> : detail.value}
                      </Col>
                    </Row>
                  )
                })
              }
              <div style={{height: '5vh'}} />
            </Col>
          </Row>
        </Container>
      }
    </Provider>
  )
}

export default Folder;
